import { LitElement, html } from 'lit';
import { FitStorageBehavior } from '../fit-storage/fit-storage-behavior';
import styles from './fit-vote.css';

class FitVote extends FitStorageBehavior(LitElement) {
  static get is() { return 'fit-vote'; }

  static get styles() { return styles; }

  render() {
    return html`
      <div class="vote-buttons">
        <button id="vote-down" aria-describedby="vote-down-tooltip" ?active="${this.vote === false}" @click="${this.toggle}" class="button button--inverted fa fa-thumbs-down"></button>
        <button id="vote-up" aria-describedby="vote-up-tooltip" ?active="${this.vote === true}" @click="${this.toggle}" class="button button--inverted fa fa-thumbs-up"></button>
      </div>
      <fit-tooltip ?hidden="${!this.voteDownLabel}" id="vote-down-tooltip">${this.voteDownLabel}</fit-tooltip>
      <fit-tooltip ?hidden="${!this.voteUpLabel}" id="vote-up-tooltip">${this.voteUpLabel}</fit-tooltip>
    `;
  }

  static get properties() {
    return {

      code: {
        type: String,
      },

      voteList: {
        type: Array,
      },

      vote: {
        type: Boolean,
      },

      voteUpLabel: {
        type: String,
        attribute: 'vote-up-label',
      },

      voteDownLabel: {
        type: String,
        attribute: 'vote-down-label',
      },

    };
  }

  get storageName() {
    return 'fit-vote';
  }

  set storageValue(voteList) {
    voteList = voteList || {};
    this.voteList = voteList;
    this.vote = (this.code && voteList && voteList[this.code] !== undefined) ? Boolean(voteList[this.code]) : null;
  }

  toggle(event) {
    if (event instanceof Event) {
      event.preventDefault();
    }
    let vote = null;
    if (event.target.id === 'vote-up') {
      vote = true;
    } else if (event.target.id === 'vote-down') {
      vote = false;
    } else {
      return;
    }

    this.voteList[this.code] = vote;
    this.saveStorageValue(this.voteList);

    const detail = {
      code: this.code,
      vote,
    };

    this.dispatchEvent(new CustomEvent('fit-vote-changed', { detail, bubbles: true, composed: true }));
    event.target.blur();
  }
}

customElements.define(FitVote.is, FitVote);
